import {BaseModel} from '../../model/shared/BaseModel';
import {requests} from '../../utils/helpers/api.services';
import {NOTIFY_COUNT_URL, NOTIFY_LIST_URL} from '../../utils/helpers/api.routes';
import {INotification} from '../../model/notification/INotification';
import {NotificationCount} from '../../model/notification/NotificationCount';

export const NotificationService = {
    getNotify: (params: any): Promise<BaseModel<INotification[]>> => requests.get(NOTIFY_LIST_URL, params),
    getNotifyCount: (): Promise<NotificationCount> => requests.get(NOTIFY_COUNT_URL)
}